import React from "react";
import {
  Spacing,
  Title,
  WithFeedbackProps,
  withFeedback,
  Card,
  Accordion,
  Paragraph,
} from "@sicredi/react";

import "./index.scss";

export const ListaDPOs: React.FC<WithFeedbackProps> = ({
  setError,
  setSucceeded,
  setException,
  clearFeedback,
}) => {
  return (
    <div className="lista-dpo-layout">
      <Title className="lista-dpo-title">
        Lei Geral de Proteção de Dados (LGPD)
      </Title>
      <Spacing appearance="xxx-large"></Spacing>
      <Card className="card-dpo">
        <Accordion aria-label="lista dpo" className="lista-dpo-accordeon">
          <Accordion.Item label="Encarregado - DPO">
            <Paragraph className="paragrafo">
              Se você tiver dúvidas ou quiser se comunicar com o Sicredi a
              respeito das informações presentes nesta Política, contate o
              Encarregado responsável pela sua cooperativa acessando a lista
              abaixo.
            </Paragraph>
            <Paragraph className="paragrafo">
              <a
                className="highlight-green"
                href="https://web-static.sicredi.io/lgpd-politica-privacidade-lib@1/pdf/media_produtos_filer_public_2024_08_28_dpo2808.pdf"
                target="_blank"
                rel="noreferrer"
              >
                Clique aqui para acessar a lista dos DPOs.
              </a>
            </Paragraph>
          </Accordion.Item>
        </Accordion>
      </Card>
    </div>
  );
};

export default withFeedback(ListaDPOs);
